import * as types from './actionTypes';
import axios from 'axios';
import { getHeader } from '../helper';

function getEmployeesRequest() {
    return {
        type: types.LOAD_EMPLOYEES_REQUEST
    }
}

function getEmployeesReceive(data) {
    return {
        type: types.LOAD_EMPLOYEES_SUCCESS,
        payload: data
    }
}

function getEmployeesError(messages) {
    return {
        type: types.LOAD_EMPLOYEES_FAILURE,
        payload: messages
    }
}

export function getEmployees(params) {
    
    return function (dispatch) {
        dispatch(getEmployeesRequest(params))

        return axios.get(`${window.siteUrl}/api/v1/participant/`, {
            params: params,
            headers: getHeader()
        })
        .then(function (response) {
            // console.log("getEmployeesReceive", response.data)
            dispatch(getEmployeesReceive(response.data));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("getEmployeesError", err.status, err.data, err.headers);
                dispatch(getEmployeesError(err.data));
            }
        });
    }
}


function getAdminsRequest() {
    return {
        type: types.LOAD_COMPANY_ADMINS_REQUEST
    }
}

function getAdminsReceive(data) {
    return {
        type: types.LOAD_COMPANY_ADMINS_SUCCESS,
        payload: data
    }
}

function getAdminsError(messages) {
    return {
        type: types.LOAD_COMPANY_ADMINS_FAILURE,
        payload: messages
    }
}

export function getAdmins(params) {
    
    return function (dispatch) {
        dispatch(getAdminsRequest(params))

        return axios.get(`${window.siteUrl}/api/v1/participant/`, {
            params: params,
            headers: getHeader()
        })
        .then(function (response) {
            dispatch(getAdminsReceive(response.data.results));
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("getAdminsError", err.status, err.data, err.headers);
                dispatch(getAdminsError(err.data));
            }
        });
    }
}



export function addEmployee(params, successCallback, errorCallback) {
    
    return function (dispatch) {
       // dispatch(getAdminsRequest(params))

        return axios.post(
            `${window.siteUrl}/api/v1/invite_to_company/`,
            params,
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
            //dispatch(AddEmployeeReceive(response.data.results));
            if(successCallback) successCallback(response.data)
        })
        .catch(function (error) {
            if (error.response.data) {
                let message;
                if(error.response.status === 500)
                    message = 'Ошибка сервера'
                else {
                    message = error.response.data
                }
                console.error("getAdminsError", message);
                if(errorCallback)
                    errorCallback(message)
                //dispatch(getAdminsError(err.data));
            }
        });
    }
}


function deleteEmployeeReceive(data) {
    return {
        type: types.DELETE_EMPLOYEE_SUCCESS,
        payload: data
    }
}

export function deleteEmployee(params, successCallback, errorCallback) {    
    return function (dispatch) {

        return axios.delete(
            `${window.siteUrl}/api/v1/participant/kick/`,
            {
                data: {...params},
                headers: getHeader()
            }
        )
        .then(function (response) {
            dispatch(deleteEmployeeReceive(params));
            if(successCallback) successCallback(response.data)
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("deleteEmployeeError", err.status, err.data, err.headers);
               // dispatch(getAdminsError(err.data));
            }
        });
    }
}


function updateEmployeeReceive(payload, user_id) {
    return {
        type: types.UPDATE_EMPLOYEE_SUCCESS,
        payload,
        user_id
    }
}

export function updateEmployee(params, successCallback, errorCallback) {
    
    return function (dispatch) {
        return axios.patch(
            `${window.siteUrl}/api/v1/participant/change/`,
            params,
            {
                headers: getHeader()
            }
        )
        .then(function (response) {
            dispatch(updateEmployeeReceive(response.data, params.user_id));
            if(successCallback) successCallback(response.data)
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("updateEmployeeError", err.status, err.data, err.headers);
               // dispatch(getAdminsError(err.data));
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/employeesActions.js